// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Dict from "common/src/util/Dict.bs.js";
import * as Link from "../Link.bs.js";
import * as React from "react";
import * as Data16 from "common/src/data/Data16.bs.js";
import * as Global from "common/src/Global.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as CdnAtom from "common/src/atoms/CdnAtom.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as ItemImage from "common/src/tft-static/ItemImage.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as TraitName0 from "common/src/tft-static/TraitName0.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ItemTooltip from "common/src/tft-static/ItemTooltip.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as UnitTooltip from "common/src/tft-static/UnitTooltip.bs.js";
import * as TraitTooltip from "common/src/tft-static/TraitTooltip.bs.js";
import * as InfoUnitCard2 from "./InfoUnitCard2.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as RitoDescription2 from "common/src/components/RitoDescription2.bs.js";

function UnitInfoPage$TraitInfo(Props) {
  var traitId = Props.traitId;
  var unitId = Props.unitId;
  var set = TftSet.use(undefined);
  var units = Belt_Array.keep(Sd.getTraitUnits(traitId, set), (function (u) {
          return u !== unitId;
        }));
  var t = Translation.useT(/* Traits */2);
  var desc = t(traitId + "_desc");
  return React.createElement("div", undefined, React.createElement(Link.make, {
                  route: {
                    TAG: /* Info */6,
                    _0: {
                      TAG: /* Traits */3,
                      _0: set
                    }
                  },
                  children: React.createElement("h4", {
                        className: "flex items-center text-lg font-medium"
                      }, React.createElement(TraitImage.PlainIcon.make, {
                            className: "mr-1",
                            traitId: traitId,
                            size: 22
                          }), React.createElement(TraitName0.make, {
                            trait: traitId
                          }))
                }), React.createElement("div", {
                  className: "flex flex-wrap"
                }, Belt_Array.map(units, (function (unitId) {
                        return React.createElement("div", {
                                    key: unitId,
                                    className: "pr-3 pt-2"
                                  }, React.createElement(Link.make, {
                                        route: {
                                          TAG: /* Info */6,
                                          _0: {
                                            TAG: /* Unit */0,
                                            _0: set,
                                            _1: unitId
                                          }
                                        },
                                        children: React.createElement(UnitTooltip.make, {
                                              unit: unitId,
                                              children: React.createElement(UnitImage.make, {
                                                    unitId: unitId,
                                                    size: 48
                                                  })
                                            })
                                      }), React.createElement("div", {
                                        className: "flex justify-center"
                                      }, Belt_Array.map(Belt_Array.keep(Sd.getUnitTraits(unitId, set), (function (t) {
                                                  return t !== traitId;
                                                })), (function (traitId) {
                                              return React.createElement(TraitTooltip.make, {
                                                          trait: traitId,
                                                          children: React.createElement(TraitImage.PlainIcon.make, {
                                                                className: "mt-[2px]",
                                                                traitId: traitId,
                                                                size: 18
                                                              }),
                                                          key: traitId
                                                        });
                                            }))));
                      }))), React.createElement("div", {
                  className: "text-sm leading-snug pt-3"
                }, React.createElement(RitoDescription2.make, {
                      desc: desc
                    })));
}

var TraitInfo = {
  make: UnitInfoPage$TraitInfo
};

function UnitInfoPage$Stat(Props) {
  var lightOpt = Props.light;
  var label = Props.label;
  var icon = Props.icon;
  var value = Props.value;
  var light = lightOpt !== undefined ? lightOpt : false;
  var basePath4 = CdnAtom.usePath4(undefined);
  var t = Translation.useT(/* Common */0);
  return React.createElement("div", {
              className: "text-sm leading-tight"
            }, React.createElement("div", undefined, t(label)), React.createElement("div", {
                  className: "flex pt-[2px]"
                }, React.createElement("div", {
                      className: "flex-shrink-0"
                    }, React.createElement("img", {
                          height: "14",
                          src: basePath4 + "/general/" + icon + ".png?w=14",
                          width: "14"
                        })), React.createElement("div", {
                      className: "pl-1 font-medium " + (
                        light ? "text-white2" : "text-white1"
                      ) + " break-all"
                    }, value)));
}

var Stat = {
  make: UnitInfoPage$Stat
};

function UnitInfoPage$TopItem(Props) {
  var itemId = Props.itemId;
  return React.createElement("div", {
              className: "pr-[6px]"
            }, React.createElement(ItemTooltip.make, {
                  itemId: itemId,
                  children: React.createElement(ItemImage.make, {
                        itemId: itemId,
                        size: 32
                      })
                }));
}

var TopItem = {
  make: UnitInfoPage$TopItem
};

var starScaling = [
  1 / 1.5,
  1,
  1.5,
  2.25,
  3
];

function UnitInfoPage$StatAd(Props) {
  var unitId = Props.unitId;
  var info = Props.info;
  var set = TftSet.use(undefined);
  var isYordle = Sd.getUnitTraits(unitId, set).includes("Set9_BandleCity");
  var ad = Belt_Array.map(Belt_Array.slice(starScaling, 1, isYordle ? 4 : 3), (function (v) {
          return Global.f(info.stats.damage) * v;
        }));
  var partial_arg = 0;
  var adString = Belt_Array.map(ad, (function (param) {
            return Global.toFixed(partial_arg, param);
          })).join("/");
  return React.createElement(UnitInfoPage$Stat, {
              label: "Attack Damage",
              icon: "ad",
              value: adString
            });
}

var StatAd = {
  starScaling: starScaling,
  make: UnitInfoPage$StatAd
};

function UnitInfoPage$StatDps(Props) {
  var info = Props.info;
  var ad = Belt_Array.map(Belt_Array.range(1, 3), (function (i) {
          return Global.f(info.stats.damage) * Math.pow(1.5, Global.f(i - 1 | 0));
        }));
  var dps = Belt_Array.map(ad, (function (ad) {
          return ad * info.stats.attackSpeed;
        }));
  var partial_arg = 0;
  var dpsString = Belt_Array.map(dps, (function (param) {
            return Global.toFixed(partial_arg, param);
          })).join("/");
  return React.createElement(UnitInfoPage$Stat, {
              label: "DPS",
              icon: "crit_chance",
              value: dpsString
            });
}

var StatDps = {
  make: UnitInfoPage$StatDps
};

function UnitInfoPage$StatAs(Props) {
  var info = Props.info;
  return React.createElement(UnitInfoPage$Stat, {
              label: "Attack Speed",
              icon: "as",
              value: Global.toFixed(undefined, Belt_Option.getWithDefault(Caml_option.nullable_to_opt(info.stats.attackSpeed), 0))
            });
}

var StatAs = {
  make: UnitInfoPage$StatAs
};

function UnitInfoPage$StatArmor(Props) {
  var info = Props.info;
  return React.createElement(UnitInfoPage$Stat, {
              label: "Armor",
              icon: "armor",
              value: String(Belt_Option.getWithDefault(Caml_option.nullable_to_opt(info.stats.armor), 0))
            });
}

var StatArmor = {
  make: UnitInfoPage$StatArmor
};

function UnitInfoPage$StatMr(Props) {
  var info = Props.info;
  return React.createElement(UnitInfoPage$Stat, {
              label: "Magic Resist",
              icon: "mr",
              value: String(Belt_Option.getWithDefault(Caml_option.nullable_to_opt(info.stats.magicResist), 0))
            });
}

var StatMr = {
  make: UnitInfoPage$StatMr
};

var starScaling$1 = [
  1 / 1.8,
  1,
  1.8,
  3.24,
  4.68
];

function UnitInfoPage$StatHp(Props) {
  var unitId = Props.unitId;
  var info = Props.info;
  var set = TftSet.use(undefined);
  var isYordle = Sd.getUnitTraits(unitId, set).includes("Set9_BandleCity");
  var hp = Belt_Array.map(Belt_Array.slice(starScaling$1, 1, isYordle ? 4 : 3), (function (v) {
          return Global.f(info.stats.hp) * v;
        }));
  var partial_arg = 0;
  var hpString = Belt_Array.map(hp, (function (param) {
            return Global.toFixed(partial_arg, param);
          })).join("/");
  return React.createElement(UnitInfoPage$Stat, {
              label: "Health",
              icon: "hp",
              value: hpString
            });
}

var StatHp = {
  starScaling: starScaling$1,
  make: UnitInfoPage$StatHp
};

function UnitInfoPage$StatRange(Props) {
  var info = Props.info;
  return React.createElement(UnitInfoPage$Stat, {
              label: "Range",
              icon: "range",
              value: String(info.stats.range)
            });
}

var StatRange = {
  make: UnitInfoPage$StatRange
};

function UnitInfoPage$StatMana(Props) {
  var info = Props.info;
  return React.createElement(UnitInfoPage$Stat, {
              light: info.stats.mana === 0,
              label: "Mana",
              icon: "mana",
              value: info.stats.mana === 0 ? "No Mana" : String(info.stats.initialMana) + " / " + String(info.stats.mana)
            });
}

var StatMana = {
  make: UnitInfoPage$StatMana
};

function UnitInfoPage$StatsGrid(Props) {
  var unitId = Props.unitId;
  var info = Props.info;
  return React.createElement("div", {
              className: "grid grid-cols-[1fr_1fr] gap-x-6 gap-y-2 text-[14px]"
            }, React.createElement(UnitInfoPage$StatAd, {
                  unitId: unitId,
                  info: info
                }), React.createElement(UnitInfoPage$StatAs, {
                  info: info
                }), React.createElement(UnitInfoPage$StatArmor, {
                  info: info
                }), React.createElement(UnitInfoPage$StatMr, {
                  info: info
                }), React.createElement(UnitInfoPage$StatHp, {
                  unitId: unitId,
                  info: info
                }), React.createElement(UnitInfoPage$StatRange, {
                  info: info
                }), React.createElement(UnitInfoPage$StatDps, {
                  info: info
                }), React.createElement(UnitInfoPage$StatMana, {
                  info: info
                }));
}

var StatsGrid = {
  make: UnitInfoPage$StatsGrid
};

function UnitInfoPage$Inner(Props) {
  var unitId = Props.unitId;
  var set = TftSet.use(undefined);
  var t = Translation.useT(/* Units */1);
  var commonT = Translation.useT(/* Common */0);
  Translation.useT(/* Augments */4);
  var basePath3 = CdnAtom.usePath4(undefined);
  var info = Dict.getExn(Data.units(set), unitId);
  var count = info.abilities;
  var match = info.itemization;
  return React.createElement(AdLayout.make, {
              children: React.createElement("div", {
                    className: "mx-auto flex flex-col items-center max-w-[900px]"
                  }, React.createElement("div", {
                        className: "grid gap-4 grid-cols-[auto] sm:grid-cols-[264px_auto]"
                      }, React.createElement(Link.make, {
                            route: {
                              TAG: /* Info */6,
                              _0: {
                                TAG: /* Units */1,
                                _0: set
                              }
                            },
                            children: React.createElement(InfoUnitCard2.make, {
                                  unit: unitId,
                                  traits: Sd.getUnitTraits(unitId, set),
                                  width: 256
                                })
                          }), React.createElement(ContentSection.make, {
                            children: null
                          }, React.createElement("h4", {
                                className: "text-lg font-medium pb-1"
                              }, commonT("Ability")), React.createElement("div", {
                                className: "flex items-center"
                              }, React.createElement("img", {
                                    height: "32px",
                                    src: basePath3 + "/ability/" + unitId + ".jpg?w=32",
                                    width: "32px"
                                  }), React.createElement("div", {
                                    className: "pl-1 font-medium"
                                  }, t(unitId + "_ability"))), React.createElement("div", {
                                className: "pt-2 leading-tight"
                              }, React.createElement(RitoDescription2.make, {
                                    desc: t(unitId + "_desc")
                                  }), React.createElement(UnitTooltip.AbilityDetails.make, {
                                    unitId: unitId,
                                    info: info
                                  })), count !== undefined ? Belt_Array.map(Belt_Array.range(0, count - 1 | 0), (function (idx) {
                                    var idx$1 = String(idx);
                                    return React.createElement(React.Fragment, {
                                                children: null,
                                                key: idx$1
                                              }, React.createElement("div", {
                                                    className: "flex items-center pt-4 font-medium"
                                                  }, t(unitId + "_ability_" + idx$1 + "_name")), React.createElement("div", {
                                                    className: "pt-2 leading-tight"
                                                  }, React.createElement(RitoDescription2.make, {
                                                        desc: unitId + "_ability_" + idx$1 + "_desc"
                                                      })));
                                  })) : null), React.createElement("div", undefined, match !== undefined ? React.createElement(ContentSection.make, {
                                  className: "mb-4",
                                  children: React.createElement("div", {
                                        className: "flex flex-col items-start"
                                      }, React.createElement("div", {
                                            className: "font-montserrat font-medium leading-none text-lg pb-2"
                                          }, commonT(Belt_Option.getExn(info.itemization) + "_items")), React.createElement("div", {
                                            className: "font-roboto text-sm leading-tight pb-2"
                                          }, React.createElement(RitoDescription2.make, {
                                                desc: commonT(Belt_Option.getExn(info.itemization) + "_desc")
                                              })), React.createElement("div", {
                                            className: "grid grid-cols-4 gap-2 flex-shrink-1"
                                          }, Belt_Array.map(Belt_Option.getExn(Js_dict.get(Data16.data.itemization, Belt_Option.getExn(info.itemization))), (function (itemId) {
                                                  return React.createElement(ItemImage.make, {
                                                              itemId: itemId,
                                                              size: 36,
                                                              rounded: "rounded",
                                                              key: itemId
                                                            });
                                                }))))
                                }) : null, React.createElement(ContentSection.make, {
                                children: null
                              }, React.createElement("h4", {
                                    className: "text-lg font-montserrat font-medium pb-1"
                                  }, commonT("Stats")), React.createElement(UnitInfoPage$StatsGrid, {
                                    unitId: unitId,
                                    info: info
                                  }))), React.createElement(ContentSection.make, {
                            children: null
                          }, React.createElement("h4", {
                                className: "text-lg font-montserrat font-medium pb-1"
                              }, commonT("Traits")), Belt_Array.map(Sd.getUnitTraits(unitId, set), (function (traitId) {
                                  return React.createElement("div", {
                                              key: traitId,
                                              className: "mb-4"
                                            }, React.createElement(UnitInfoPage$TraitInfo, {
                                                  traitId: traitId,
                                                  unitId: unitId
                                                }));
                                })))))
            });
}

var Inner = {
  make: UnitInfoPage$Inner
};

function UnitInfoPage(Props) {
  var topItems = Props.topItems;
  var unitId = Props.unitId;
  var set = Props.set;
  return React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(TftSet.fromNum(set), React.createElement(UnitInfoPage$Inner, {
                      topItems: topItems,
                      unitId: unitId
                    }), undefined));
}

var make = UnitInfoPage;

export {
  TraitInfo ,
  Stat ,
  TopItem ,
  StatAd ,
  StatDps ,
  StatAs ,
  StatArmor ,
  StatMr ,
  StatHp ,
  StatRange ,
  StatMana ,
  StatsGrid ,
  Inner ,
  make ,
  
}
/* Sd Not a pure module */
